import * as React from "react";

import connectToList from "../../store/list";

import GenButton from "../Gen/Button";
import GenControlsBar from "../Gen/ControlsBar";
import GenListDisplay from "../Gen/ListDisplay";
import GenMore from "../Gen/More";
import GenSearchBox from "../Gen/SearchBox";
import GenSelectBar from "../Gen/SelectBar";
import GenSortButtons from "../Gen/SortButtons";

interface DocumentSetUserPermissionCreateSelectListProps {
  documentSetId: number;
  groupRoleDefinitionUsers: ConnectedList<GroupRoleDefinitionUserSnakeModel>;
}

function DocumentSetUserPermissionCreateSelectList(props: DocumentSetUserPermissionCreateSelectListProps) {
  const {
    documentSetId,
    groupRoleDefinitionUsers,
  } = props;

  React.useEffect(() => {
    groupRoleDefinitionUsers.mountList(`/document_sets/${documentSetId}/document_set_user_permissions/new_batch_list`);
  }, []);

  const [isSubmitLoading, setIsSubmitLoading] = React.useState(false);

  const handleSubmitButton = React.useCallback(() => {
    if (groupRoleDefinitionUsers.selected.length === 0) {
      alert("No Members Selected! You must select at least one user to add from list.");
      return;
    }

    const data = {
      groupRoleDefinitionUserIds: groupRoleDefinitionUsers.selected.map((groupRoleDefinitionUser) => groupRoleDefinitionUser.id),
    };

    setIsSubmitLoading(true);

    fetch(`/document_sets/${documentSetId}/document_set_user_permissions/create_batch_list`, {
      method: "POST",
      body: JSON.stringify(data),
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    })
      .then((response) => {
        if (!response.ok) { throw new Error(`${response.status} response` ); }

        return response.json();
      })
      .then(Turbo.visit(`/document_sets/${documentSetId}/document_set_user_permissions`))
      .catch(() => {
        setIsSubmitLoading(false);
      });
  }, [documentSetId, groupRoleDefinitionUsers.selected]);

   return(
     <div>
       <div className="submit-panel">
         <h1>Add Members</h1>
         <GenButton
           name="Add Members"
           highlighted
           disabled={groupRoleDefinitionUsers.selected.length === 0}
           loading={isSubmitLoading}
           onClick={handleSubmitButton}
         />
       </div>
       <GenSelectBar
         {...groupRoleDefinitionUsers}
         itemType="member(s)"
       />
       <GenControlsBar>
         <GenSearchBox
           {...groupRoleDefinitionUsers}
         />
         <GenSortButtons
           {...groupRoleDefinitionUsers}
           sortOptions={[
            {
              "title": "First Name",
              "value": "first_name",
            },
            {
              "title": "Last Name",
              "value": "last_name",
            },
            {
              "title": "Email",
              "value": "email",
            },
          ]}
         />
       </GenControlsBar>
       <GenListDisplay
         {...groupRoleDefinitionUsers}
         renderItem={(grdu) => <span>{grdu.user.email} -- {grdu.user.first_name} {grdu.user.last_name} -- {grdu.role_definition.name}</span>}
       />
       <GenMore
         {...groupRoleDefinitionUsers}
         shouldInfiniteScroll
       />
     </div>
   );
}

export default connectToList(DocumentSetUserPermissionCreateSelectList, ["groupRoleDefinitionUsers"]);
